export default __webpack_public_path__ + "static/media/gas_app_partners_hori_icon.1da4bc89.svg";